<style scoped>
</style>
<template>
	<div>
		<Table :columns="tableColumn" :data="ChargeDetails" size="small"></Table>
	</div>
</template>
<script>
	export default {
		props: {
			row: Object
		},
		data() {
			return {
				tableColumn: [{
						title: this.$tt('充电订单号'),
						key: 'ChargeOrderNo',
					}, {
						title: this.$tt('充电枪编码'),
						key: 'ConnectorNo',
					}, {
						title: this.$tt('插枪时间'),
						key: 'PluginsInTime',
					}, {
						title: this.$tt('拔枪时间'),
						key: 'PluginsOutTime'
					}, {
						title: this.$tt('充电开始时间'),
						key: 'ChargeStartTime',
					}, {
						title: this.$tt('充电结束时间'),
						key: 'ChargeEndTime',
					}, {
						title: this.$tt('充电时长(分钟)'),
						key: 'ChargeDuration',
					}, {
						title: this.$tt('减免类型'),
						key: 'DerateTypeDesc',
					},
				],
				ChargeDetails: this.row.ChargeDetails,
			}
		},

		methods: {
		}
	};
</script>
